/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/gcp-wif-principal/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiGcpWifPrincipalAppGroupId } from "./constants";
import type { GetIntegrationsDirectCdiGcpWifPrincipalAppGroupIdResult } from "./types";
import { isGetIntegrationsDirectCdiGcpWifPrincipalAppGroupIdResult } from "./validators";

export const getIntegrationsDirectCdiGcpWifPrincipalAppGroupId = reactQueryFetcherAdapter(
  integrationsDirectCdiGcpWifPrincipalAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<GetIntegrationsDirectCdiGcpWifPrincipalAppGroupIdResult> => {
    return fetch(`/integrations/direct/cdi/gcp-wif-principal/${appGroupId}`, "GET", {}, { signal });
  },
  isGetIntegrationsDirectCdiGcpWifPrincipalAppGroupIdResult
);
